import React, { useRef, useEffect, useState } from 'react';
import { createTheme, Grid, ThemeProvider } from '@mui/material';
import { useData } from '../../contexts';
import { Vogelvlucht } from '../Pages/Vogelvlucht/Vogelvlucht';
import { Evolutiescore } from '../Pages/Evolutiescore/Evolutiescore';
import { EvolutiescoreRegister } from '../Pages/EvolutiescoreRegister/EvolutiescoreRegister';
import { Indexscore } from '../Pages/Indexscore/Indexscore';
import { Cluster } from '../Pages/Cluster/Cluster';
import { ArrowNavigation } from '../ArrowNavigation/ArrowNavigation';
import { VogelvluchtRegister } from '../Pages/VogelvluchtRegister/VogelvluchtRegister';
import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { MdOutlineMenu } from 'react-icons/md';
import useSWR from 'swr';
import { VogelvluchtMobile } from '../Pages/VogelvluchtMobile/VogelvluchtMobile';
import { IndexscoreMobile } from '../Pages/IndexscoreMobile/IndexscoreMobile';
import { EvolutiescoreMobile } from '../Pages/EvolutiescoreMobile/EvolutiescoreMobile';
import { EvolutiescoreRegisterMobile } from '../Pages/EvolutiescoreRegisterMobile/EvolutiescoreRegisterMobile';
import { VogelvluchtRegisterMobile } from '../Pages/VogelvluchtRegisterMobile/VogelvluchtRegisterMobile';
import { ClusterMobile } from '../Pages/ClusterMobile/ClusterMobile';

interface DataContext {
  additionalData: {
    pageSettings: Queries.config_pages__page_settings;
    allIndicators: Queries.node__indicator[];
  };
}

export default function DashboardCity({
  additionalData,
}: DataContext): React.JSX.Element {
  const {
    selectedGemeente,
    selectedBenchmarks,
    setSelectedBenchmarks,
    setSelectedGemeente,
    colors,
    selectedTopic,
    setSelectedTopic,
    searchParams,
    setSearchParams,
    blobUrl,
    blobUrlDashboard,
    blobUrlSamenvattingen,
    isDesktop,
    isMobile,
    isTablet,
    interfaceColor,
  } = useData();

  const [toggled, setToggled] = React.useState(false);
  const [hasRunOnce, setHasRunOnce] = React.useState(false);
  const [gemeenteLijst, setGemeenteLijst] = useState([]);
  const [benchmarkLijst, setBenchmarkLijst] = useState([]);
  const [dataVogelVluchtSurvey, setDataVogelVluchtSurvey] = useState([]);
  const [dataIndexSurvey, setDataIndexSurvey] = useState([]);
  const [dataEvolutieSurvey, setDataEvolutieSurvey] = useState([]);
  const [dataVogelVluchtRegister, setDataVogelVluchtRegister] = useState([]);
  const [dataEvolutieRegister, setDataEvolutieRegister] = useState([]);
  const [aantalInwoners, setAantalInwoners] = useState({
    aantalInwoners: null,
    jaar: null,
    idRuimte: null,
    d3format: ',.0f',
  });
  const [showSurvey, setShowSurvey] = useState(false);
  const [showRegister, setShowRegister] = useState(false);

  // const [gemeenteFilter, setGemeenteFilter] = useQueryParam(
  //   'city',
  //   StringParam,
  // );

  const fetcher = (url: any) => fetch(url).then((res) => res.json());

  const swrOptions = {
    // revalidateOnFocus: false,
    // revalidateOnMount: false,
    // revalidateOnReconnect: false,
    // refreshWhenOffline: false,
    // refreshWhenHidden: false,
    // refreshInterval: 0,
  };

  const { data: d_ruimte } = useSWR(
    `${blobUrl}d_ruimte.json`,
    fetcher,
    swrOptions,
  );

  const { data: d_thema } = useSWR(
    `${blobUrl}d_thema.json`,
    fetcher,
    swrOptions,
  );
  const { data: d_indicator_detail } = useSWR(
    `${blobUrl}d_indicator_detail.json`,
    fetcher,
    swrOptions,
  );

  const { data: f_samenvatting_indicatoren } = useSWR(
    `${blobUrlSamenvattingen}f_samenvatting_indicatoren.json`,
    fetcher,
    swrOptions,
  );

  const { data: d_indicator_dashboard } = useSWR(
    `${blobUrlDashboard}d_indicator_dashboard.json`,
    fetcher,
    swrOptions,
  );

  const gemeenteFile = `f_dashboard_${selectedGemeente.id}`;
  const { data: f_dashboard } = useSWR(
    `${blobUrlDashboard}${gemeenteFile}.json`,
    fetcher,
    swrOptions,
  );

  const benchmarkFile = `f_dashboard_${selectedBenchmarks[0].id}`;
  const { data: f_dashboardBench } = useSWR(
    `${blobUrlDashboard}${benchmarkFile}.json`,
    fetcher,
    swrOptions,
  );

  const { data: f_dashboard2000 } = useSWR(
    `${blobUrlDashboard}f_dashboard_2000.json`,
    fetcher,
    swrOptions,
  );

  const { data: f_inwonersAantal } = useSWR(
    `${blobUrl}f_inwonersAantal.json`,
    fetcher,
    swrOptions,
  );

  const theme = createTheme({
    typography: {
      allVariants: {
        fontFamily: 'Flanders Art Sans',
        fontSize: '1.4rem',
      },
    },
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: '14px',
          },
        },
      },
    },
  });

  // const cityDashboardPath =
  //   additionalData.pageSettings.relationships.field_dashboard_city.path.alias;

  const onChangeOnderwerpHandler = (event: any) => {
    setSelectedTopic(JSON.parse(event.target.value));
  };

  function useUrlUpdate(url: string) {
    if (typeof window !== `undefined` && typeof url !== `undefined`) {
      window.history.pushState({}, '', url);
    }
    return;
  }

  const onChangeGemeenteHandler = (event: any) => {
    event.preventDefault();
    let tmp = JSON.parse(event.target.value);
    tmp.label = tmp.ruimte;
    setSelectedGemeente(tmp);

    // navigate(`${cityDashboardPath}?gemeente=${tmp.ruimte}`);

    setSearchParams((params) => {
      params.set('gemeente', tmp.ruimte);
      return params;
    });

    const trimmedUrl = window.location.href.split('/').shift();
    const path =
      additionalData?.pageSettings?.relationships?.field_dashboard_city?.path
        ?.alias;
    const url = `${trimmedUrl}${path}?gemeente=${tmp.ruimte}`;

    useUrlUpdate(url);
  };

  const onChangeBenchmarkHandler = (event: any) => {
    event.preventDefault();
    let tmp = [];
    tmp[0] = JSON.parse(event.target.value);
    tmp[0].label = tmp[0].ruimte;
    setSelectedBenchmarks(tmp);
  };

  const getAndSetRuimteByLabel = (label: any) => {
    if (label !== null) {
      const records = d_ruimte.filter((d: any) => {
        return d.ruimte === label && parseInt(d.isFusie) === 0;
      });

      if (records !== undefined && records.length > 0) {
        let ruimte = structuredClone(records[0]);
        ruimte.id = parseInt(ruimte.id);
        ruimte.label = ruimte.ruimte;
        setSelectedGemeente(ruimte);

        const trimmedUrl = window.location.href.split('/').shift();
        const path =
          additionalData?.pageSettings?.relationships?.field_dashboard_city
            ?.path?.alias;
        const url = `${trimmedUrl}${path}?gemeente=${ruimte.ruimte}`;

        const param = searchParams.get('indicator');
        if (param) {
          searchParams.delete('indicator');
        }

        setSearchParams((params) => {
          params.set('gemeente', ruimte.ruimte);
          return params;
        });
        useUrlUpdate(url);
      } else {
        getAndSetDefaultRuimteByLabel(label);
      }
    }
  };

  const getAndSetDefaultRuimteByLabel = (label: any) => {
    let defaultGemeente = d_ruimte.find((d: any) => d.ruimte === 'Aalst');
    defaultGemeente.label = defaultGemeente.ruimte;
    setSelectedGemeente(defaultGemeente);
    setToggled(true);

    const trimmedUrl = window.location.href.split('/').shift();
    const path =
      additionalData?.pageSettings?.relationships?.field_dashboard_city?.path
        ?.alias;
    const url = `${trimmedUrl}${path}?gemeente=${defaultGemeente.ruimte}`;
    const param = searchParams.get('indicator');
    if (param) {
      searchParams.delete('indicator');
    }

    setSearchParams((params) => {
      params.set('gemeente', defaultGemeente.ruimte);
      return params;
    });
    useUrlUpdate(url);
  };

  useEffect(() => {
    if (d_ruimte && !hasRunOnce) {
      if (selectedBenchmarks.length > 0) {
        setSelectedBenchmarks((prev) => {
          return prev.filter((d: any) => {
            return d.isFusie === 0;
          });
        });
      }
      const searchKeyword = searchParams.get('gemeente');

      if (searchKeyword === null && selectedGemeente.id === -1) {
        // let defaultGemeente = d_ruimte.find((d: any) => d.ruimte === 'Aalst');
        // defaultGemeente.label = defaultGemeente.ruimte;
        // setSelectedGemeente(defaultGemeente);
        // setToggled(true);

        // const trimmedUrl = window.location.href.split('/').shift();
        // const path =
        //   additionalData?.pageSettings?.relationships?.field_dashboard_city
        //     ?.path?.alias;
        // const url = `${trimmedUrl}${path}?gemeente=${defaultGemeente.ruimte}`;
        // const param = searchParams.get('indicator');
        // if (param) {
        //   searchParams.delete('indicator');
        // }

        // setSearchParams((params) => {
        //   params.set('gemeente', defaultGemeente.ruimte);
        //   return params;
        // });
        // useUrlUpdate(url);
        getAndSetDefaultRuimteByLabel(searchKeyword);
      } else {
        getAndSetRuimteByLabel(searchKeyword);
      }
      setHasRunOnce(true);
    } else if (d_ruimte && hasRunOnce) {
      const trimmedUrl = window.location.href.split('/').shift();
      const path =
        additionalData?.pageSettings?.relationships?.field_dashboard_city?.path
          ?.alias;
      const url = `${trimmedUrl}${path}?gemeente=${selectedGemeente.ruimte}`;
      const param = searchParams.get('indicator');
      if (param) {
        searchParams.delete('indicator');
      }

      setSearchParams((params) => {
        params.set('gemeente', selectedGemeente.ruimte);
        return params;
      });
      useUrlUpdate(url);
    }
  }, [hasRunOnce, d_ruimte, selectedGemeente]);

  const vogelvluchtSection = useRef(null);
  const indexSection = useRef(null);
  const evolutieSection = useRef(null);
  const vogelvluchtRegisterSection = useRef(null);
  const evolutieRegisterSection = useRef(null);
  const clusterSection = useRef(null);
  const linkSection = useRef(null);

  const sideBarJSX = (
    <Sidebar
      id="mySideBar"
      width="300px"
      onBackdropClick={() => setToggled(false)}
      toggled={toggled}
      backgroundColor="#fff"
      breakPoint="all"
    >
      <Menu
        style={{
          paddingTop: '52px',
        }}
        menuItemStyles={{
          button: ({ level, active, disabled }) => {
            return {
              paddingLeft: '2rem',
              paddingRight: '2rem',
              listStyleType: 'none',
              height: '8rem',
            };
          },
        }}
      >
        <MenuItem>
          Kies een gemeente
          <div className="vl-form-col--12-12" style={{ padding: '0.6rem' }}>
            <select
              name="city"
              className="vl-select vl-select--block"
              tabIndex={0}
              data-vl-select=""
              data-vl-select-search-empty-text="Geen resultaten gevonden"
              onChange={onChangeGemeenteHandler}
            >
              {/* <option disabled value="none">
                  Kies je gemeente
                </option> */}
              {gemeenteLijst.map((d: any, i: number) => (
                <option
                  key={d.id}
                  value={JSON.stringify(d)}
                  selected={d.ruimte === selectedGemeente.label}
                >
                  {d.ruimte}
                </option>
              ))}
            </select>
          </div>
        </MenuItem>

        <MenuItem>
          Kies een benchmark
          <div className="vl-form-col--12-12" style={{ padding: '0.6rem' }}>
            {/* <select
              name="city"
              className="vl-select vl-select--block"
              tabIndex={0}
              data-vl-select=""
              data-vl-select-search-empty-text="Geen resultaten gevonden"
              onChange={onChangeBenchmarkHandler}
            >
              {benchmarkLijst !== undefined &&
                benchmarkLijst.map((d: any, i: number) => (
                  <option
                    key={d.id}
                    value={JSON.stringify(d)}
                    selected={d.ruimte === selectedBenchmarks[0].label}
                  >
                    {d.ruimte}
                  </option>
                ))}
            </select> */}

            <select
              name="gemeente"
              className="vl-select vl-select--block"
              tabIndex={0}
              data-vl-select=""
              data-vl-select-search-empty-text="Geen resultaten gevonden"
              onChange={onChangeBenchmarkHandler}
            >
              <optgroup label="Gebiedsomschrijvingen">
                {benchmarkLijst !== undefined &&
                  benchmarkLijst
                    .filter((d: any) => d.bench === 1)
                    .map((d: any, i: number) => (
                      <option
                        key={d.id}
                        value={JSON.stringify(d)}
                        selected={
                          selectedBenchmarks.length > 0 &&
                          d.ruimte === selectedBenchmarks[0].label
                        }
                      >
                        {d.ruimte}
                      </option>
                    ))}
              </optgroup>
              <optgroup label="Gemeenten">
                {benchmarkLijst !== undefined &&
                  benchmarkLijst
                    .filter((d: any) => d.bench === 0)
                    .map((d: any, i: number) => (
                      <option
                        key={d.id}
                        value={JSON.stringify(d)}
                        selected={
                          selectedBenchmarks.length > 0 &&
                          d.ruimte === selectedBenchmarks[0].label
                        }
                      >
                        {d.ruimte}
                      </option>
                    ))}
              </optgroup>
            </select>
          </div>
        </MenuItem>

        <MenuItem>
          Kies een thema
          <div className="vl-form-col--12-12" style={{ padding: '0.6rem' }}>
            <select
              name="city"
              className="vl-select vl-select--block"
              tabIndex={0}
              data-vl-select=""
              data-vl-select-search-empty-text="Geen resultaten gevonden"
              onChange={onChangeOnderwerpHandler}
            >
              {d_thema !== undefined &&
                d_thema.map((d: any, i: number) => (
                  <option
                    key={d.id}
                    value={JSON.stringify(d)}
                    selected={d.thema === selectedTopic.thema}
                  >
                    {d.thema.charAt(0).toUpperCase() +
                      d.thema.slice(1).toLowerCase()}
                  </option>
                ))}
            </select>
          </div>
        </MenuItem>

        <MenuItem onClick={() => setToggled(false)}>
          <button
            className="vl-button"
            vl-button
            style={{ backgroundColor: interfaceColor }}
          >
            <span className="vl-button__label">Sluiten</span>
          </button>
        </MenuItem>
      </Menu>
    </Sidebar>
  );

  const mainJSX = (
    <main
      style={{
        position: 'sticky',
        top: 4,
        zIndex: 10,
        height: 0,
        width: '100%',
      }}
    >
      <div>
        <button
          className="sb-button"
          onClick={() => setToggled(!toggled)}
          style={{
            float: 'left',
            marginLeft: '20px',
            marginTop: '10px',
            padding: 0,
            border: 0,
            fontSize: '6rem',
          }}
        >
          <MdOutlineMenu fill={interfaceColor} />
        </button>
      </div>
    </main>
  );

  const contentJSX = (
    <div style={{ width: '100%' }}>
      <Grid
        item
        xs={12}
        p={2}
        pt={2}
        pl={14}
        sx={{ position: 'relative', width: '50%' }}
      >
        <p style={{ fontSize: '0.8em' }}>
          <u>Opgelet</u>: Voor de nieuwe fusiegemeenten zijn nog niet alle
          registerindicatoren beschikbaar, als gevolg van nieuwe berekeningen
          bij de dataproducent. Je kan nagaan voor welke registerindicatoren
          momenteel al data beschikbaar zijn{' '}
          <a
            href={
              process.env.BLOB_STORAGE_BASE_URL +
              'documentatie/fusies/gemeentestadsmonitor_data_fusiegemeenten.xlsx'
            }
            target="_blank"
          >
            in dit overzicht
          </a>
          . De registerdata van de vroegere gemeenten kan je downloaden{' '}
          <a href={'download-alle-cijfers'} target="_blank">
            op deze pagina
          </a>
          . Voor de survey-indicatoren kan je de gegevens van de vroegere
          gemeenten terugvinden{' '}
          <a
            href={
              additionalData?.pageSettings?.relationships?.field_fusion_data
                ?.path?.alias
            }
            target="_blank"
          >
            op deze pagina
          </a>
          .
        </p>
      </Grid>

      {!showSurvey && !showRegister && (
        <Grid
          item
          xs={12}
          p={2}
          pt={0}
          height={'100vh'}
          minHeight={'700px'}
          sx={{ position: 'relative', width: '100%' }}
          ref={vogelvluchtSection}
        >
          Geen data beschikbaar voor de gekozen gemeente.
        </Grid>
      )}

      {showSurvey && (
        <>
          <Grid
            item
            xs={12}
            p={2}
            pt={0}
            height={'100vh'}
            minHeight={'700px'}
            sx={{ position: 'relative', width: '100%' }}
            ref={vogelvluchtSection}
          >
            <ArrowNavigation
              up={null}
              down={evolutieSection}
              current={vogelvluchtSection}
            />
            <Vogelvlucht
              data={dataVogelVluchtSurvey}
              clickHandler={() => setToggled(!toggled)}
              allIndicators={additionalData.allIndicators}
              interactieveToolPath={
                additionalData?.pageSettings?.relationships?.field_dashboard
                  ?.path?.alias
              }
              aantalInwoners={aantalInwoners}
            />
          </Grid>

          <Grid
            item
            xs={12}
            p={2}
            pt={0}
            height={'100vh'}
            minHeight={'700px'}
            sx={{ position: 'relative' }}
            ref={evolutieSection}
          >
            <ArrowNavigation
              up={vogelvluchtSection}
              down={indexSection}
              current={evolutieSection}
            />
            <Evolutiescore
              data={dataEvolutieSurvey}
              clickHandler={() => setToggled(!toggled)}
              allIndicators={additionalData.allIndicators}
              interactieveToolPath={
                additionalData?.pageSettings?.relationships?.field_dashboard
                  ?.path?.alias
              }
            />
          </Grid>

          <Grid
            item
            xs={12}
            p={2}
            pt={0}
            height={'100vh'}
            minHeight={'700px'}
            sx={{ position: 'relative' }}
            ref={indexSection}
          >
            <ArrowNavigation
              up={evolutieSection}
              down={showRegister ? vogelvluchtRegisterSection : null}
              current={indexSection}
            />
            <Indexscore
              data={dataIndexSurvey}
              clickHandler={() => setToggled(!toggled)}
              allIndicators={additionalData.allIndicators}
              interactieveToolPath={
                additionalData?.pageSettings?.relationships?.field_dashboard
                  ?.path?.alias
              }
            />
          </Grid>
        </>
      )}

      {showRegister && (
        <>
          <Grid
            item
            xs={12}
            p={2}
            pt={0}
            height={'100vh'}
            minHeight={'700px'}
            sx={{ position: 'relative' }}
            ref={vogelvluchtRegisterSection}
          >
            <ArrowNavigation
              up={showSurvey ? indexSection : null}
              down={evolutieRegisterSection}
              current={vogelvluchtRegisterSection}
            />
            <VogelvluchtRegister
              data={dataVogelVluchtRegister}
              clickHandler={() => setToggled(!toggled)}
              allIndicators={additionalData.allIndicators}
              interactieveToolPath={
                additionalData?.pageSettings?.relationships?.field_dashboard
                  ?.path?.alias
              }
              indicatorPagina={
                additionalData?.pageSettings?.relationships
                  ?.field_indicator_page?.path?.alias
              }
            />
          </Grid>

          <Grid
            item
            xs={12}
            p={2}
            pt={0}
            height={'100vh'}
            minHeight={'700px'}
            sx={{ position: 'relative' }}
            ref={evolutieRegisterSection}
          >
            <ArrowNavigation
              up={vogelvluchtRegisterSection}
              down={null}
              current={evolutieRegisterSection}
              top={showSurvey ? vogelvluchtSection : vogelvluchtRegisterSection}
            />
            <EvolutiescoreRegister
              data={dataEvolutieRegister}
              clickHandler={() => setToggled(!toggled)}
              allIndicators={additionalData.allIndicators}
              interactieveToolPath={
                additionalData?.pageSettings?.relationships?.field_dashboard
                  ?.path?.alias
              }
            />
          </Grid>
        </>
      )}
    </div>
  );

  const mainJSXMobile = (
    <main
      style={{
        position: 'sticky',
        top: 16,
        zIndex: 10,
        height: 0,
        width: '100%',
      }}
    >
      <div>
        <button
          className="sb-button"
          onClick={() => setToggled(!toggled)}
          style={{
            float: 'left',
            marginLeft: '6px',
            marginTop: '12px',
            padding: 0,
            border: 0,
            fontSize: '3rem',
          }}
        >
          <MdOutlineMenu fill={colors[0]} />
        </button>
      </div>
    </main>
  );

  const contentJSXMobile = (
    <div style={{ width: '100%' }}>
      <Grid container style={{ width: '100%' }}>
        <Grid
          item
          xs={12}
          p={2}
          pt={2}
          pl={5}
          pr={4}
          sx={{ position: 'relative', width: '100%' }}
        >
          <p style={{ fontSize: '0.8em' }}>
            <u>Opgelet</u>: Voor de nieuwe fusiegemeenten zijn nog niet alle
            registerindicatoren beschikbaar, als gevolg van nieuwe berekeningen
            bij de dataproducent. Je kan nagaan voor welke registerindicatoren
            momenteel al data beschikbaar zijn{' '}
            <a
              href={
                process.env.BLOB_STORAGE_BASE_URL +
                'documentatie/fusies/gemeentestadsmonitor_data_fusiegemeenten.xlsx'
              }
              target="_blank"
            >
              in dit overzicht
            </a>
            . De registerdata van de vroegere gemeenten kan je downloaden{' '}
            <a href={'download-alle-cijfers'} target="_blank">
              op deze pagina
            </a>
            . Voor de survey-indicatoren kan je de gegevens van de vroegere
            gemeenten terugvinden{' '}
            <a
              href={
                additionalData?.pageSettings?.relationships?.field_fusion_data
                  ?.path?.alias
              }
              target="_blank"
            >
              op deze pagina
            </a>
            .
          </p>
        </Grid>

        {!showSurvey && !showRegister && (
          <Grid item xs={12} marginBottom={'50px'}>
            Geen data beschikbaar voor de gekozen gemeente.
          </Grid>
        )}

        {showSurvey && (
          <>
            <Grid item xs={12} marginBottom={'50px'}>
              <VogelvluchtMobile
                data={dataVogelVluchtSurvey}
                allIndicators={additionalData.allIndicators}
                interactieveToolPath={
                  additionalData?.pageSettings?.relationships?.field_dashboard
                    ?.path?.alias
                }
                aantalInwoners={aantalInwoners}
              />
            </Grid>

            <Grid item xs={12} marginBottom={'50px'}>
              <EvolutiescoreMobile
                data={dataEvolutieSurvey}
                allIndicators={additionalData.allIndicators}
                interactieveToolPath={
                  additionalData?.pageSettings?.relationships?.field_dashboard
                    ?.path?.alias
                }
              />
            </Grid>

            <Grid item xs={12} marginBottom={'50px'}>
              <IndexscoreMobile
                data={dataIndexSurvey}
                allIndicators={additionalData.allIndicators}
                interactieveToolPath={
                  additionalData?.pageSettings?.relationships?.field_dashboard
                    ?.path?.alias
                }
              />
            </Grid>
          </>
        )}

        {showRegister && (
          <>
            <Grid item xs={12} marginBottom={'50px'}>
              <VogelvluchtRegisterMobile
                data={dataVogelVluchtRegister}
                allIndicators={additionalData.allIndicators}
                interactieveToolPath={
                  additionalData?.pageSettings?.relationships?.field_dashboard
                    ?.path?.alias
                }
                indicatorPagina={
                  additionalData?.pageSettings?.relationships
                    ?.field_indicator_page?.path?.alias
                }
              />
            </Grid>

            <Grid item xs={12} marginBottom={'50px'}>
              <EvolutiescoreRegisterMobile
                data={dataEvolutieRegister}
                allIndicators={additionalData.allIndicators}
                interactieveToolPath={
                  additionalData?.pageSettings?.relationships?.field_dashboard
                    ?.path?.alias
                }
              />
            </Grid>
          </>
        )}
      </Grid>
    </div>
  );

  useEffect(() => {
    if (
      d_ruimte &&
      d_thema &&
      d_indicator_dashboard &&
      f_dashboard &&
      f_dashboardBench &&
      f_dashboard2000 &&
      f_samenvatting_indicatoren &&
      d_indicator_detail &&
      f_inwonersAantal
    ) {
      const dataIndicators = d_indicator_dashboard.filter(
        (d: any) => d.idThema === selectedTopic.id,
      );

      const tmpGemeente = f_dashboard.filter(
        (d: any) => d.idThema === selectedTopic.id,
      );

      const tmpBench = f_dashboardBench.filter(
        (d: any) => d.idThema === selectedTopic.id,
      );

      const tmp2000 = f_dashboard2000.filter(
        (d: any) => d.idThema === selectedTopic.id,
      );

      const dataIndicatorsSurvey = dataIndicators.filter(
        (d: any) => d.oorsprong === 'Survey',
      );

      const dataIndicatorsRegister = dataIndicators.filter(
        (d: any) => d.oorsprong === 'Register',
      );

      const inwonersAantal = f_inwonersAantal.find(
        (d: any) => d.idRuimte === selectedGemeente.id,
      );

      inwonersAantal.d3format = ',.0f';
      setAantalInwoners(inwonersAantal);

      // SURVEYDATA VOGELVLUCHT
      /* 
      {
        id: 1,  
        label: 'Tevredenheid buurt',
        value: 96,
        valueBench: 60,
        valueMax: 100,
      },
      */

      let showSurveyTMP = false;
      let showRegisterTMP = false;

      tmpGemeente.map((d: any) => {
        const hasDataSurvey = dataIndicatorsSurvey.find(
          (a: any) => a.id === d.idIndicator,
        );
        const hasDataRegister = dataIndicatorsRegister.find(
          (a: any) => a.id === d.idIndicator,
        );

        if (hasDataSurvey) showSurveyTMP = true;
        if (hasDataRegister) showRegisterTMP = true;
      });

      setShowSurvey(showSurveyTMP);
      setShowRegister(showRegisterTMP);

      const dataVogelVluchtSurveyTMP = dataIndicatorsSurvey.map((d: any) => {
        const gem = tmpGemeente.find((a: any) => a.idIndicator === d.id);
        const ben = tmpBench.find((a: any) => a.idIndicator === d.id);
        const vlgew = tmp2000.find((a: any) => a.idIndicator === d.id);
        const det = d_indicator_detail.find(
          (a: any) => a.id === d.idIndicatorDetail,
        );

        if (det !== undefined) det.definitie = d.definitie;

        const d3format =
          det && det.numberFormat
            ? det.ratio === '%'
              ? `,.${parseInt(det.decimalen)}%`
              : `,.${parseInt(det.decimalen)}f`
            : ',.0%';

        return {
          ...d,
          value: gem ? gem.value : null,
          valueBench: ben ? ben.value : null,
          valueMax: 1,
          detail: det ? det : null,
          d3format: d3format,
          sortering: gem ? gem.sortering : ben ? ben.sortering : null,
          jaar:
            gem && gem.jaar
              ? gem.jaar
              : ben && ben.jaar
              ? ben.jaar
              : vlgew && vlgew.jaar
              ? vlgew.jaar
              : null,
        };
      });

      if (
        dataVogelVluchtSurveyTMP.length > 0 &&
        dataVogelVluchtSurveyTMP[0].value !== null
      ) {
        dataVogelVluchtSurveyTMP.sort((a: any, b: any) => b.value - a.value);
      }

      setDataVogelVluchtSurvey(dataVogelVluchtSurveyTMP);

      // DATA INDEXSCORE BURGERBEVRAGING
      /*
      {
        id: 11,
        label: 'Voldoende consultatie bewoners',
        value: 105,
        valueBench: 96,
        indexScore: 103,
      },
    */

      const dataIndexSurveyTMP = dataIndicatorsSurvey.map((d: any) => {
        const gem = tmpGemeente.find((a: any) => a.idIndicator === d.id);
        const ben = tmpBench.find((a: any) => a.idIndicator === d.id);
        const det = d_indicator_detail.find(
          (a: any) => a.id === d.idIndicatorDetail,
        );
        const sum = f_samenvatting_indicatoren.find(
          (a: any) =>
            a.idIndicator === d.idIndicator &&
            a.idIndicatorP1 === d.idIndicatorP1,
          // && a.idIndicatorP2 === d.idIndicatorP2,
          // only check on id and p1 for dashboard data
        );

        const d3format =
          det && det.numberFormat
            ? det.ratio === '%'
              ? `,.${parseInt(det.decimalen)}%`
              : `,.${parseInt(det.decimalen)}f`
            : ',.0%';

        if (det !== undefined) det.definitie = d.definitie;

        const value = gem ? gem.value : null;
        const valueBench = ben ? ben.value : null;
        const delta =
          valueBench === 0 ? null : (value - valueBench) / valueBench;
        const deltaAbs = value - valueBench;

        return {
          ...d,
          name: d.label,
          value: value,
          valueBench: valueBench,
          //valueBench: sum ? sum.valueVlaamsGewest : null, // Altijd vlaams gewest tonen voor indexscore
          indexScore: gem ? gem.indexScore : null,
          indexScoreVisual: gem ? gem.indexScore - 100 : null,
          delta: delta,
          deltaAbs: deltaAbs,
          d3format: d3format,
          detail: det ? det : null,
          gemeente: selectedGemeente.label,
          bench: selectedBenchmarks[0].label,
          jaar: gem && gem.jaar ? gem.jaar : ben && ben.jaar ? ben.jaar : null,
        };
      });

      dataIndexSurveyTMP.sort((a: any, b: any) => b.deltaAbs - a.deltaAbs);

      setDataIndexSurvey(dataIndexSurveyTMP);

      // DATA EVOLUTIESCORE BURGERBEVRAGING

      const dataEvolutieSurveyTMP = dataIndicatorsSurvey.map((d: any) => {
        const gem = tmpGemeente.find((a: any) => a.idIndicator === d.id);
        const ben = tmpBench.find((a: any) => a.idIndicator === d.id);
        const det = d_indicator_detail.find(
          (a: any) => a.id === d.idIndicatorDetail,
        );

        if (det !== undefined) det.definitie = d.definitie;

        const d3format =
          det && det.numberFormat
            ? det.ratio === '%'
              ? `,.${parseInt(det.decimalen)}%`
              : `,.${parseInt(det.decimalen)}f`
            : ',.0%';

        // return {
        //   ...d,
        //   jaar: gem && gem.jaar ? gem.jaar : ben && ben.jaar ? ben.jaar : null,
        //   jaarVorig:
        //     gem && gem.jaarVorig
        //       ? gem.jaarVorig
        //       : ben && ben.jaarVorig
        //       ? ben.jaarVorig
        //       : null,
        //   value: gem ? gem.evolutieScore : null,
        //   valueBench: ben ? ben.evolutieScore : null,
        //   valueStatusQuo: 100,
        //   valueReal: gem ? gem.value : null,
        //   valueRealVorig: gem ? gem.valueVorig : null,
        //   valueRealBench: ben ? ben.value : null,
        //   valueRealBenchVorig: ben ? ben.valueVorig : null,
        //   delta: gem ? gem.delta : null,
        //   deltaBench: ben ? ben.delta : null,
        //   d3format: d3format,
        //   detail: det ? det : null,
        // };

        return {
          ...d,
          name: d.label,
          jaar: gem && gem.jaar ? gem.jaar : ben && ben.jaar ? ben.jaar : null,
          jaarVorig:
            gem && gem.jaarVorig
              ? gem.jaarVorig
              : ben && ben.jaarVorig
              ? ben.jaarVorig
              : null,
          valueReal: gem ? gem.value : null,
          valueRealVorig: gem ? gem.valueVorig : null,
          valueRealBench: ben ? ben.value : null,
          valueRealBenchVorig: ben ? ben.valueVorig : null,
          delta: gem ? gem.deltaPercent : null,
          deltaBench: ben ? ben.deltaPercent : null,
          deltaAbs: gem ? gem.delta : null,
          deltaAbsBench: ben ? ben.delta : null,
          d3format: d3format,
          detail: det ? det : null,
        };
      });

      // dataEvolutieSurveyTMP.sort((a: any, b: any) => {
      //   let fa = a.label.toLowerCase(),
      //     fb = b.label.toLowerCase();

      //   if (fa < fb) {
      //     return -1;
      //   }
      //   if (fa > fb) {
      //     return 1;
      //   }
      //   return 0;
      // });

      dataEvolutieSurveyTMP.sort((a: any, b: any) => b.deltaAbs - a.deltaAbs);

      setDataEvolutieSurvey(dataEvolutieSurveyTMP);

      // DATA VOGELVLUCHT REGISTERDATABANK
      /*
        {
          id: 1,
          label: 'Tevredenheid buurt',
          Antwerpen: 110,
          Boom: 90,
          valueVlaamsGewest: 100,
          valueMin: 40,
          valueMax: 160,
        },
      */

      const dataVogelVluchtRegisterTMP = dataIndicatorsRegister.map(
        (d: any) => {
          const gem = tmpGemeente.find((a: any) => a.idIndicator === d.id);
          const ben = tmpBench.find((a: any) => a.idIndicator === d.id);
          const vlgew = tmp2000.find((a: any) => a.idIndicator === d.id);
          const sum = f_samenvatting_indicatoren.find(
            (a: any) =>
              a.idIndicator === d.idIndicator &&
              a.idIndicatorP1 === d.idIndicatorP1 &&
              a.idIndicatorP2 === d.idIndicatorP2,
          );
          const det = d_indicator_detail.find(
            (a: any) => a.id === d.idIndicatorDetail,
          );

          const d3format =
            det && det.numberFormat
              ? det.ratio === '%'
                ? `,.${parseInt(det.decimalen)}%`
                : `,.${parseInt(det.decimalen)}f`
              : ',.1f';

          const valueSort =
            gem && sum
              ? (gem.value - sum.valueMin) / (sum.valueMax - sum.valueMin)
              : null;

          if (det !== undefined) det.definitie = d.definitie;

          return {
            ...d,
            valueSort: valueSort,
            valueMax: sum ? sum.valueMax : null,
            valueMin: sum ? sum.valueMin : null,
            valueVlaamsGewest: sum ? sum.valueVlaamsGewest : null,
            [selectedGemeente.label]: gem ? gem.value : null,
            [selectedBenchmarks[0].label]: ben ? ben.value : null,
            sortering: gem && gem.sortering ? gem.sortering : null,
            detail: det ? det : null,
            d3format: d3format,
            jaar:
              gem && gem.jaar
                ? gem.jaar
                : ben && ben.jaar
                ? ben.jaar
                : vlgew && vlgew.jaar
                ? vlgew.jaar
                : null,
          };
        },
      );

      dataVogelVluchtRegisterTMP.sort(
        (a: any, b: any) => a.sortering - b.sortering,
      );

      setDataVogelVluchtRegister(dataVogelVluchtRegisterTMP);

      // DATA EVOLUTIESCORE REGISTERDATABANK
      /*
        {
          id: 10,
          label: 'Voldoende consultatie bewoners2',
          value: 105,
          valueBench: 123,
          valueStatusQuo: 100,
        },
      */

      const dataEvolutieRegisterTMP = dataIndicatorsRegister.map((d: any) => {
        const gem = tmpGemeente.find((a: any) => a.idIndicator === d.id);
        const ben = tmpBench.find((a: any) => a.idIndicator === d.id);
        const det = d_indicator_detail.find(
          (a: any) => a.id === d.idIndicatorDetail,
        );

        if (det !== undefined) det.definitie = d.definitie;

        const d3format =
          det && det.numberFormat
            ? det.ratio === '%'
              ? `,.${parseInt(det.decimalen)}%`
              : `,.${parseInt(det.decimalen)}f`
            : ',.1f';

        // return {
        //   ...d,
        //   jaar: gem && gem.jaar ? gem.jaar : ben && ben.jaar ? ben.jaar : null,
        //   jaarVorig:
        //     gem && gem.jaarVorig
        //       ? gem.jaarVorig
        //       : ben && ben.jaarVorig
        //       ? ben.jaarVorig
        //       : null,
        //   value: gem ? gem.evolutieScore : null,
        //   valueBench: ben ? ben.evolutieScore : null,
        //   valueStatusQuo: 100,
        //   valueReal: gem ? gem.value : null,
        //   valueRealVorig: gem ? gem.valueVorig : null,
        //   valueRealBench: ben ? ben.value : null,
        //   valueRealBenchVorig: ben ? ben.valueVorig : null,
        //   delta: gem ? gem.delta : null,
        //   deltaBench: ben ? ben.delta : null,
        //   d3format: d3format,
        //   detail: det ? det : null,
        // };

        return {
          ...d,
          name: d.label,
          jaar: gem && gem.jaar ? gem.jaar : ben && ben.jaar ? ben.jaar : null,
          jaarVorig:
            gem && gem.jaarVorig
              ? gem.jaarVorig
              : ben && ben.jaarVorig
              ? ben.jaarVorig
              : null,
          valueReal: gem ? gem.value : null,
          valueRealVorig: gem ? gem.valueVorig : null,
          valueRealBench: ben ? ben.value : null,
          valueRealBenchVorig: ben ? ben.valueVorig : null,
          delta: gem ? gem.deltaPercent : null,
          deltaBench: ben ? ben.deltaPercent : null,
          deltaAbs: gem ? gem.delta : null,
          deltaAbsBench: ben ? ben.delta : null,
          d3format: d3format,
          detail: det ? det : null,
        };
      });

      // dataEvolutieRegisterTMP.sort((a: any, b: any) => {
      //   let fa = a.label.toLowerCase(),
      //     fb = b.label.toLowerCase();

      //   if (fa < fb) {
      //     return -1;
      //   }
      //   if (fa > fb) {
      //     return 1;
      //   }
      //   return 0;
      // });

      dataEvolutieRegisterTMP.sort((a: any, b: any) => b.delta - a.delta);

      setDataEvolutieRegister(dataEvolutieRegisterTMP);

      const vlgewest = d_ruimte.filter((d: any) => {
        return parseInt(d?.isVlaamsGewest) === 1;
      });

      const centrumSteden = d_ruimte.filter((d: any) => {
        return parseInt(d?.is13CentrumSteden) === 1;
      });

      const belfius = d_ruimte.filter((d: any) => {
        return (
          parseInt(d.id) === parseInt(selectedGemeente?.idRuimteBelfiusCluster)
        );
      });

      const gemGrootte = d_ruimte.filter((d: any) => {
        return (
          parseInt(d.id) === parseInt(selectedGemeente?.idRuimteGemeenteGrootte)
        );
      });

      const prov = d_ruimte.filter((d: any) => {
        return parseInt(d.id) === parseInt(selectedGemeente?.idRuimteProvincie);
      });

      const regio = d_ruimte.filter((d: any) => {
        return parseInt(d.id) === parseInt(selectedGemeente?.idRuimteRegio);
      });

      const allBench = vlgewest
        .concat(prov, regio, belfius, gemGrootte, centrumSteden)
        .map((d: any) => {
          d.bench = 1;
          return d;
        });

      const sortedCities = d_ruimte
        .filter((d: any) => {
          return (
            parseInt(d.isVlaamseGemeente) === 1 && parseInt(d.isFusie) === 0
          );
        })

        .sort((a: any, b: any) => {
          let fa = a.ruimte.toLowerCase(),
            fb = b.ruimte.toLowerCase();

          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
          return 0;
        })
        .map((d: any) => {
          d.bench = 0;
          return d;
        });

      // const citiesBench = vlgewest.concat(sortedCities);
      const citiesBench = allBench.concat(sortedCities).filter((d: any) => {
        return parseInt(d.id) !== parseInt(selectedGemeente?.id);
      });

      setGemeenteLijst(sortedCities);
      setBenchmarkLijst(citiesBench);
    }
  }, [
    d_ruimte,
    d_thema,
    d_indicator_dashboard,
    f_dashboard,
    f_dashboardBench,
    f_samenvatting_indicatoren,
    f_inwonersAantal,
    d_indicator_detail,
    selectedTopic,
    selectedGemeente,
    selectedBenchmarks,
  ]);

  useEffect(() => {
    if (d_ruimte) {
      const vlgewest = d_ruimte.filter((d: any) => {
        return parseInt(d?.isVlaamsGewest) === 1;
      });

      const centrumSteden = d_ruimte.filter((d: any) => {
        return parseInt(d?.is13CentrumSteden) === 1;
      });

      const facil = d_ruimte.filter((d: any) => {
        return parseInt(d?.isFaciliteitenGemeente) === 1;
      });

      const nietFacil = d_ruimte.filter((d: any) => {
        return parseInt(d?.isNietFaciliteitenGemeente) === 1;
      });

      const vlRand = d_ruimte.filter((d: any) => {
        return parseInt(d?.isVlaamseRand) === 1;
      });

      const belfius = d_ruimte.filter((d: any) => {
        return (
          parseInt(d.id) === parseInt(selectedGemeente?.idRuimteBelfiusCluster)
        );
      });

      const gemGrootte = d_ruimte.filter((d: any) => {
        return (
          parseInt(d.id) === parseInt(selectedGemeente?.idRuimteGemeenteGrootte)
        );
      });

      const prov = d_ruimte.filter((d: any) => {
        return parseInt(d.id) === parseInt(selectedGemeente?.idRuimteProvincie);
      });

      const regio = d_ruimte.filter((d: any) => {
        return parseInt(d.id) === parseInt(selectedGemeente?.idRuimteRegio);
      });

      const allBench = vlgewest
        .concat(
          prov,
          regio,
          belfius,
          gemGrootte,

          centrumSteden,
          vlRand,
          facil,
          nietFacil,
        )
        .map((d: any) => {
          d.bench = 1;
          return d;
        });
      // compare currently selected benchmarks with benchmarks in list to see if there are no illegal selections
      const uniqueBenchIDs = [...new Set(allBench.map((d: any) => d.id))];

      let selBench = selectedBenchmarks.filter((d: any) => {
        return parseInt(d.isGemeente) || uniqueBenchIDs.includes(d.id);
      });

      if (selBench.length === 0) {
        selBench = d_ruimte.find((d: any) => parseInt(d.isVlaamsGewest) === 1);
        selBench.label = selBench.ruimte;
        selBench = [selBench];
      }

      setSelectedBenchmarks(selBench);
    }
  }, [d_ruimte, selectedGemeente]);

  return (
    <section>
      <ThemeProvider theme={theme}>
        <Grid
          container
          className="vl-typography background-0"
          minHeight="500px"
          pt={2}
        >
          {d_ruimte && d_thema && sideBarJSX}
          {d_ruimte && d_thema && isDesktop ? mainJSX : mainJSXMobile}

          {d_ruimte &&
          d_thema &&
          d_indicator_dashboard &&
          d_indicator_detail &&
          f_dashboard &&
          f_dashboardBench &&
          f_samenvatting_indicatoren ? (
            isDesktop ? (
              contentJSX
            ) : (
              contentJSXMobile
            )
          ) : (
            <div>{/* <p>Fout bij het laden van de data</p> */}</div>
          )}
        </Grid>
      </ThemeProvider>
    </section>
  );
}
